<template>
    <v-menu>
        <template #activator="{on}">
            <v-btn v-on="on" outlined small>
                <v-icon small left>mdi-pencil</v-icon>
                Define the currency
            </v-btn>
        </template>

        <v-list>
            <v-list-item v-for="currency in currencies" :key="currency.currency"  @click="changeCurrency(currency)">
                <v-list-item-title>{{ currency.currency }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props:{
        po:{
            type: Object,
            required: true
        }
    },
    computed:{
        ...mapGetters('currencies', ['currencies'])
    },
    methods:{
        ...mapActions('purchaseOrders', ['setCurrency']),
        changeCurrency(currency) {
            this.setCurrency({poId:this.po.id,currency:currency.currency})
            .then(() => {
                this.$emit('change')
            })
        }
    }
}
</script>